import wtApiClient from "./wtApiClient";

export const locationApi = {
    getCountries: () => {
        const url = "/categories/countries";
        return wtApiClient.get(url);
    },
    getStates: (countriesId: number | string) => {
        let url = "/categories/states";
        if (countriesId) {
            url += `?countries=${countriesId}`;
        }
        return wtApiClient.get(url);
    },
    getRegions: ({
        stateId,
        countryId,
    }: {
        stateId?: number | string;
        countryId?: number | string;
    }) => {
        let url = "/categories/regions";
        if (stateId) {
            url += `?states=${stateId}`;
        } else if (countryId) {
            url += `?countries=${countryId}`;
        }
        return wtApiClient.get(url);
    },

    getTowns: ({
        regionId,
        countryId,
    }: {
        regionId?: number | string;
        countryId?: number | string;
    }) => {
        let url = "/categories/locality";
        if (regionId) {
            url += `?regions=${regionId}`;
        } else {
            url += `?countries=${countryId}`;
        }
        return wtApiClient.get(url);
    },
};
